export const tags = [
  'javascript', 
  'typescript', 
  'angular',
  'node',
  'react',
  'firebase',
  'mongodb',
  'vue', 
  'laravel', 
  'php',
  'html',
  'css'
]